// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import store from './store'
import router from './router'
import VueRouter from "vue-router"
import axios from 'axios'
import $ from 'jquery'

import md5 from 'js-md5'

// 打印
import Print from 'vue-print-nb'
Vue.use(Print);

import global from './globalDatas'//全局变量及方法
import {setCookie,delCookie,delAllCookie} from './assets/cookie'//设置、删除cookie

Vue.config.productionTip = false

Vue.prototype.axios = axios;

Vue.prototype.$md5 = md5;//md5加密
// Vue.prototype.HOST = '/api'//全局api
// Vue.prototype.HOST = 'https://api.argylehotels.com'
if (process.env.NODE_ENV === 'production') {
  // 生产环境下的操作
    Vue.prototype.HOST = 'https://api.argylehotels.com'//线上库
} else {
  // 开发环境下的操作
  Vue.prototype.HOST = '/api'//全局api
}
Vue.prototype.GLOBAL=global

Vue.use(ElementUI);
Vue.use(Vuex)
Vue.use(VueRouter)

Vue.prototype.$cookieStore={
    setCookie,
    delCookie,
    delAllCookie
}


axios.defaults.withCredentials=false;//让ajax携带cookie
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store:store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js